import { useEffect, useState } from 'react';
import CardProduct from '../../card/CardProduct/CardProduct';
import LeftMenuDesign from '../../common/LeftMenuDesign/LeftMenuDesign';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInsideAccessories } from '../../../store/actions/insideAccessory.action';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import DropdownFilter from '../../common/DropdownFilter/DropdownFilter';
import ButtonIconOutlineMedium from '../../common/ButtonIconOutline/ButtonIconOutlineMedium';
import SearchComponent from '../../common/SearchComponent/SearchComponent';
import ButtonIconGhostMedium from '../../common/ButtonIconGhost/ButtonIconGhostMedium';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';
import { GeometryUtils } from '../../../utils/geometry/GeometryUtils';

const LeftAccessoryCustomDesignMenu = ({
  open,
  onDragStart,
  title,
  productType,
  sceneManager,
}) => {
  const dispatch = useDispatch();
  const { insideAccessories } = useSelector(state => state.insideAccessory);
  const [keyWord, setKeyWord] = useState('');

  // const { products } = useSelector(state => state.product);

  // Fetch khi product_type đổi (lần đầu + mọi lần đổi)
  useEffect(() => {
    if (!productType) return;
    dispatch(fetchInsideAccessories(productType));
  }, [dispatch, productType]);

  // Nếu nơi khác set cờ reload, fetch lại với productType hiện tại
  useEffect(() => {
    if (!productType) return;
    if (insideAccessories?.isNeedReloadData) {
      dispatch(fetchInsideAccessories(productType));
    }
  }, [dispatch, productType, insideAccessories?.isNeedReloadData]);

  // const insides = insideAccessories?.data?.insides ?? [];
  const accessories = insideAccessories?.data?.accessories ?? [];

  // Lọc accessories dựa trên type và width của cloneModule
  const filteredAccessories = accessories.filter(accessory => {
    // Nếu type là 7, 13, hoặc 17 thì lọc theo width
    if ([7, 13].includes(accessory.type)) {
      try {
        const cloneModule =
          sceneManager?.cabinetManager?.currentCabinet?.getCloneModule();

        if (!cloneModule) return false;

        const accessoryWidth = (accessory.width + 34) / 1000;

        const cloneModuleWidth =
          cloneModule.formularController?.currentDimensions?.width;
        if (cloneModule.moduleType.includes('corner')) {
          const matCD = GeometryUtils.getMeshByName(
            cloneModule.group,
            'MAT-CO-DINH'
          );
          if (!matCD) return false;
          const size = GeometryUtils.getSize(matCD);
          let width = 0;
          if (size.x < size.z) {
            width =
              cloneModule.formularController?.currentOptions?.rongK1 -
              cloneModule.formularController?.currentDimensions?.depth -
              cloneModule.formularController?.currentOptions?.truHaoGoc -
              cloneModule.formularController?.currentOptions?.DDTBia;
          } else {
            width =
              cloneModule.formularController?.currentOptions?.rongK2 -
              cloneModule.formularController?.currentDimensions?.depth -
              cloneModule.formularController?.currentOptions?.truHaoGoc -
              cloneModule.formularController?.currentOptions?.DDTBia;
          }
          return Number(accessoryWidth.toFixed(3)) === Number(width.toFixed(3));
        } else {
          return (
            Number(accessoryWidth.toFixed(3)) ===
            Number(cloneModuleWidth.toFixed(3))
          );
        }
      } catch (error) {
        console.error('Error getting cloneModule:', error);
        return false;
      }
    }

    // Nếu type khác 7, 13 thì hiển thị tất cả
    return true;
  });

  return (
    <LeftMenuDesign
      open={open}
      classNames={{
        root: '!left-[72px] relative',
        content: '!p-0 gap-0',
      }}
      header={
        <div className={'flex flex-col gap-4 self-stretch grow'}>
          <span className="text-title-large text-nowrap">{title}</span>
          <div className="left-accessory-custom-design-menu-header-actions bg-fills-white">
            <div className="flex self-stretch py-[2px]">
              <SearchComponent
                value={keyWord}
                setValue={setKeyWord}
                size="small"
                styles={{ input: { width: '100%' } }}
                className={'grow'}
              />
            </div>
          </div>
        </div>
      }
      content={
        <>
          <div className="grid grid-cols-2 p-8 items-start align-content-start gap-2">
            {filteredAccessories
              ?.filter(
                item => item.name.includes(keyWord) || keyWord.trim() === ''
              )
              ?.map((md, i) => {
                const name = getValueFromString(md.name);
                const description = getValueFromString(md.description);
                return (
                  <CardProduct
                    key={i}
                    md={md}
                    title={name}
                    description1={
                      md.width && md.depth && md.height ? (
                        <span className="text-body-small text-nowrap">
                          {`R${md.width ?? '--'} * S${md.depth ?? '--'} * C${
                            md.height ?? '--'
                          }`}
                        </span>
                      ) : null
                    }
                    description2={convertForeignCurrency(md.price)}
                    moduleType={i}
                    onDragStart={onDragStart}
                  />
                );
              })}
          </div>
        </>
      }
    />
  );
};

export default LeftAccessoryCustomDesignMenu;
